<template>
  <div>
    <ca-heading text="Cadastro do funcionário"></ca-heading>
    <ca-heading text="Dados do contrato" size="extra-small"></ca-heading>

    <ca-row-divider></ca-row-divider>

    <ca-wizard>
      <ca-wizard-step
        ref="firstStep"
        v-bind="$attrs"
        name="Dados básicos"
        hide-buttons
        v-on="$listeners">
        <worker-form-page :next-step="() => $refs.firstStep.next()"></worker-form-page>
      </ca-wizard-step>

      <ca-wizard-step
        ref="secondStep"
        v-bind="$attrs"
        name="Trabalhistas"
        hide-buttons
        v-on="$listeners">
        <worker-job-info-form-page
          :previous-step="() => $refs.secondStep.back()"
          :next-step="() => $refs.secondStep.next()"
          @on-reset-steps="onResetSteps">
        </worker-job-info-form-page>
      </ca-wizard-step>

      <ca-wizard-step
        ref="thirdStep"
        v-bind="$attrs"
        name="Contrato"
        hide-buttons
        v-on="$listeners">
        <worker-contract-info-form-page
          :previous-step="() => $refs.thirdStep.back()"
          :next-step="() => $refs.thirdStep.next()"
          @on-reset-steps="onResetSteps">
        </worker-contract-info-form-page>
      </ca-wizard-step>

      <ca-wizard-step
        ref="fourthStep"
        v-bind="$attrs"
        name="Jornada de trabalho"
        hide-buttons
        v-on="$listeners">
        <worker-shift-info-page
          :previous-step="() => $refs.fourthStep.back()"
          :next-step="() => $refs.fourthStep.next()"
          @on-reset-steps="onResetSteps">
        </worker-shift-info-page>
      </ca-wizard-step>

      <ca-wizard-step
        ref="fifthStep"
        v-bind="$attrs"
        name="Concluir"
        hide-buttons
        v-on="$listeners">
        <conclude-wizard-step
          :previous-step="() => $refs.fifthStep.back()"
          @on-reset-steps="onResetSteps"></conclude-wizard-step>
      </ca-wizard-step>
    </ca-wizard>
  </div>
</template>

<script>
import WorkerFormPage from './WorkerFormPage';
import WorkerJobInfoFormPage from './components/info-job/WorkerJobInfoFormPage';
import WorkerContractInfoFormPage from './components/contract-info/WorkerContractInfoFormPage';
import WorkerShiftInfoPage from './components/shift-info/WorkerShiftInfoPage';
import ConcludeWizardStep from './components/ConcludeWizardStep';
import { clickNewWorker } from './workerTrackerService';

export default {
  name: 'WorkerWizardPage',
  components: {
    WorkerFormPage,
    WorkerJobInfoFormPage,
    WorkerContractInfoFormPage,
    WorkerShiftInfoPage,
    ConcludeWizardStep,
  },
  created() {
    clickNewWorker();
  },
  methods: {
    onResetSteps() {
      this.$router.push({ name: 'NewWorker' });
    },
  },
};
</script>
